// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c9715b1b","93":"c2976b63","473":"990eb3df","597":"d1f2d791"}[chunkId] + ".chunk.js";
};